import { Users, UserCheck } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { ROLE_LABELS, roleNotesFor } from "@/lib/helpContentSales";

// „Wer sieht das?“ + „Für deine Rolle“ im Hilfe-Fenster.
export function HelpAudience({ content }) {
  if (!content?.audience) return null;
  return (
    <div className="inline-flex items-start gap-1.5 text-[11.5px] text-zinc-300 bg-zinc-900/70 border border-zinc-800 rounded-lg px-2.5 py-1.5 mb-3"
         data-testid="help-audience">
      <Users size={12} className="text-sky-300 mt-0.5 flex-shrink-0" />
      <span><b className="text-zinc-100">Wer sieht das?</b> {content.audience}</span>
    </div>
  );
}

export function HelpRoleNotes({ content }) {
  const { user } = useAuth();
  const notes = roleNotesFor(content, user?.role);
  if (!notes.length) return null;
  return (
    <div className="rounded-xl border border-amber-400/40 bg-amber-400/[0.06] px-3 py-2.5 mb-5" data-testid="help-role-notes">
      <div className="text-[10.5px] uppercase tracking-wider text-amber-200 font-bold mb-1.5 inline-flex items-center gap-1">
        <UserCheck size={12} /> Für deine Rolle · {ROLE_LABELS[user.role] || user.role}
      </div>
      <ul className="space-y-1">
        {notes.map((n, i) => (
          <li key={i} className="text-[12.5px] text-zinc-100 leading-snug">{n}</li>
        ))}
      </ul>
    </div>
  );
}
